import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, y = 28 }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const Kicker = ({ children, light = false }) => (
    <p
        className={`font-display text-xs font-medium uppercase tracking-[0.28em] ${
            light ? "text-chitta-sky" : "text-sky-ink"
        }`}
    >
        {children}
    </p>
);
